/**
 * Application path constants
 * Centralized path definitions for consistent routing
 */

export const Path = {
  // Authentication paths
  LOGIN: 'login',

  // Main application paths
  DASHBOARD: 'dashboard',

  // Development-only component playground
  UI_PLAYGROUND: 'ui-playground',

  // User management paths
  USERS: 'users',
  USERS_CREATE: 'create',
  USERS_EDIT: 'edit',
  USERS_VIEW: 'view',

  // synchronization paths
  SYNCHRONIZATION: 'synchronization',

  // Admin paths
  SYNC_CONFIG: 'sync-configuration',

  // Organization paths
  ORGANIZATION: 'organization',

  // Project Management paths
  PROJECTS: 'projects',
  PROJECT_FORM: 'project-form',
  PROJECT_CREATE: 'create',
  PROJECT_EDIT: 'edit',
  PROJECT_VIEW: 'view',
  ACCOUNTS: 'accounts',
  CONTACTS: 'contacts',
  CONTRACT_TYPES: 'contract-types',
  PROJECT_SETTINGS: 'project-settings',

  // Contract paths
  CONTRACTS: 'contracts',
  CONTRACT_VIEW: 'view',

  // Admin paths - Custom Variables
  CUSTOM_VARIABLES: 'custom-variables',

  // Sync Reports paths
  SYNC_REPORTS: 'reports/sync',
  SYNC_REPORTS_AZURE: 'azure',
  SYNC_REPORTS_ZOHO: 'zoho',

  // Reports paths
  REPORTS: 'reports',
  SYNC_REPORTS_PAGE: 'sync-reports',
  FIXED_REPORTS: 'fixed-reports',

  // Opportunities paths
  OPPORTUNITIES: 'opportunities',
  OPPORTUNITY_NEW: 'new',
  OPPORTUNITY_EDIT: 'edit',
  OPPORTUNITY_SERVICE_DETAILS: 'service-details',
  OPPORTUNITY_SERVICES: 'services',
  OPPORTUNITY_VIEW: 'view',

  // Estimation paths
  ESTIMATION: 'estimation',
  ESTIMATION_NEW: 'new',
  ESTIMATION_EDIT: 'edit',
  GENERATE_PROPOSAL: 'generate-proposal',

  // Per Employee Per Project Report
  PER_EMPLOYEE_PER_PROJECT: 'per-employee-per-project',

  // Per Employee Per Period Report
  PER_EMPLOYEE_PER_PERIOD: 'per-employee-per-period',

  // Per Project Per Period Report
  PER_PROJECT_PER_PERIOD: 'per-project-per-period',

  // Resource Management paths
  RESOURCE_MANAGEMENT_OVERVIEW: 'resource-management/overview',
  RESOURCE_MANAGEMENT_TIMESHEET: 'resource-management/timesheet',
  RESOURCE_MANAGEMENT_ESTIMATIONS: 'resource-management/estimations',
  // The percentage method has its own entry point: the same estimation screens
  // mounted again, listing only the estimations that started as percentage.
  RESOURCE_MANAGEMENT_PERCENTAGE_ESTIMATIONS:
    'resource-management/percentage-estimations',
  RESOURCE_MANAGEMENT_JOB_TITLES: 'resource-management/job-titles',
  RESOURCE_MANAGEMENT_SETTINGS: 'resource-management/settings',

  // Document Centre
  DOCUMENT_CENTRE: 'document-centre',

  // Future paths (commented for reference)
  // ADMIN_INTEGRATION: 'admin/integration',
  // PROJECTS: 'projects',
} as const;

export type PathType = (typeof Path)[keyof typeof Path];
